import { memo } from "react";

import { Text } from "@react/components/Text";

const RichTextBase = ({ content }: { content: string }) => {
  return (
    <Text>
      <span
        className="richText"
        dangerouslySetInnerHTML={{ __html: content }}
      />
    </Text>
  );
};

export const RichText = memo(RichTextBase);
